import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';

function JourneyPlaceholder({ t }) {
  return (
    <div className="m-portlet m-portlet--rounded">
      <div className="m-portlet__body course-container-body">
        <div className="journey-empty-step">
          <div className="journey-empty-step-text">
            {t('journey_noJourney')}
          </div>
        </div>
      </div>
    </div>
  );
}

JourneyPlaceholder.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(JourneyPlaceholder);
